import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

// Renders either a hosted external URL or a storage-served image via bearer token.
export default function VehiclePhoto({ vehicle, className = "" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let revoked = null;
    (async () => {
      if (vehicle.external_photos && vehicle.external_photos[0]) {
        setSrc(vehicle.external_photos[0]);
        return;
      }
      const p = vehicle.photos && vehicle.photos[0];
      if (!p) { setSrc(null); return; }
      try {
        const res = await api.get(`/files/${p}`, { responseType: "blob" });
        const url = URL.createObjectURL(res.data);
        revoked = url;
        setSrc(url);
      } catch {
        setSrc(null);
      }
    })();
    return () => { if (revoked) URL.revokeObjectURL(revoked); };
  }, [vehicle]);

  if (!src) return <div className={`bg-slate-200 ${className}`} />;
  return <img src={src} alt="vehicle" className={className} />;
}
